import React, { createContext, useState } from 'react';

import OrgUnitData from './OrgUnitData';

export const OrgUnitLocalStateContext = createContext();

const OrgUnitContextProviderLocal = ({ children }) => {
  const stateHook = useState(OrgUnitData.INITIAL_STATE);

  return (
    <OrgUnitLocalStateContext.Provider value={stateHook}>
      {children}
    </OrgUnitLocalStateContext.Provider>
  );
};

export default OrgUnitContextProviderLocal;